// extracted by mini-css-extract-plugin
module.exports =  {"button":"_93444fe79c--button--CJuWB","badge":"_93444fe79c--badge--kr1av"};